/**
 * The version of the build being looked at.
 *
 * Two sources, because Vite's `define` is only applied by `vite build`: on a dev
 * server the globals below stay undefined. So the version is read from
 *   - the bundle (production build; vite.config.ts reads version.json), else
 *   - the SPA shell's data attributes, rendered by Symfony from the same
 *     version.json (see templates/app/index.html.twig).
 * Anything built without the generator degrades to "dev" instead of lying.
 */

const shell = (() => {
  // #root is already in the DOM: the entry script sits at the end of <body>.
  const root = document.getElementById('root');
  return {
    version: root?.dataset.appVersion ?? '',
    full: root?.dataset.appVersionFull ?? '',
    commit: root?.dataset.appCommit ?? '',
    builtAt: root?.dataset.appBuildTime ?? '',
  };
})();

const bundled = {
  version: typeof __APP_VERSION__ === 'string' ? __APP_VERSION__ : '',
  full: typeof __APP_VERSION_FULL__ === 'string' ? __APP_VERSION_FULL__ : '',
  commit: typeof __APP_COMMIT__ === 'string' ? __APP_COMMIT__ : '',
  builtAt: typeof __APP_BUILD_TIME__ === 'string' ? __APP_BUILD_TIME__ : '',
};

/** "1.0.2610131432" — what the app calls itself. */
export const APP_VERSION: string = bundled.version || shell.version || 'dev';

/** With the commit: "1.0.2610131432+5072646". Used as the Sentry release. */
export const APP_VERSION_FULL: string = bundled.full || shell.full || APP_VERSION;

export const APP_COMMIT: string = bundled.commit || shell.commit;
export const APP_BUILD_TIME: string = bundled.builtAt || shell.builtAt;

/**
 * One muted line for footers: "1.0.2610131432 · 5072646".
 *
 * The commit is what makes it actionable: the version alone only says when the
 * code was written, the pair says exactly which revision is being looked at.
 */
export const VERSION_LABEL: string = APP_COMMIT && !APP_VERSION.includes(APP_COMMIT)
  ? `${APP_VERSION} · ${APP_COMMIT}`
  : APP_VERSION;

/** ISO timestamp of the build, when known. */
export const VERSION_TITLE: string | undefined = APP_BUILD_TIME
  ? `${APP_VERSION_FULL} — ${APP_BUILD_TIME}`
  : undefined;
